// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__DPcvi","row":"ProcedureTreatmentSummary_row__1DH4z"};